import moment from 'moment';
import column from '../../../../common/list-table/helpers/columns';

export default (data, onRowEdit, userRole) => {
  const {
    FilteredTextColumn, ActionColumn, FilteredNullableBooleanColumn, FilteredDateColumn,
  } = column(data);
  const conditionalDisplay = (row) => (row.original.validTo ? moment(row.original.validTo).isAfter(moment().subtract(1, 'day')) : true);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Handler', 'handlerName'),
        new FilteredNullableBooleanColumn('Print receipt', 'printReceipt'),
        new FilteredDateColumn('Valid from', 'validFrom'),
        new FilteredDateColumn('Valid to', 'validTo'),
        new ActionColumn([['EDIT', 'handlerName', onRowEdit, true, conditionalDisplay]]).withShow(['IPC_ADMIN', 'OPER_ADMIN'].includes(userRole)),
      ],
    },
  ];
};
